/// <reference path="./PayTableProperties.ts" />
import { SlingoStyle } from "@lib/titan2-slingo/dist/game/view/abstract/style/SlingoStyle";
import { SpineProperties } from "@lib/titan2/dist/game/control/properties/SpineProperties";
import * as PIXI from "pixi.js";
import { PayTableProperties } from "./PayTableProperties";
import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { GameFontStyle } from "../style/GameFontStyle";
/**
 * MiniPayTableProperties.ts
 */
export class MiniPayTableProperties extends PayTableProperties {
    equals(other) {
        return super.equals(other);
    }
    setDefaultValues() {
        super.setDefaultValues();
        this.cellLabel = undefined;
        this.animationProperties = new SpineProperties("MiniPayLadder", SlingoStyle.MODULE, new PIXI.Point(602, 18));
        this.cellValue = new TextFieldProperties(GameFontStyle.MINI_PAY_TABLE_CELL_VALUE, new PIXI.Point(0, -42), null, ControlConstants.CENTER, ControlConstants.CENTER, new PIXI.Point(145, 85));
        this.cellCurrentHighlightValue = new TextFieldProperties(GameFontStyle.MINI_PAY_TABLE_CELL_CURRENT_HIGHLIGHT_VALUE, new PIXI.Point(0, -42), null, ControlConstants.CENTER, ControlConstants.CENTER, new PIXI.Point(145, 85));
        this.cellPrizeExceededValue = new TextFieldProperties(GameFontStyle.MINI_PAY_TABLE_CELL_EXCEEDED_VALUE, new PIXI.Point(0, -42), null, ControlConstants.CENTER, ControlConstants.CENTER, new PIXI.Point(145, 85));
    }
}
//# sourceMappingURL=MiniPayTableProperties.js.map